import React from 'react';

export const PdpSharedPaymentCardsLazy = React.lazy(() =>
    import(
        /* webpackChunkName: "PdpSharedPaymentCards" */
        './PdpSharedPaymentCards'
    )
);
